<template>
  <div id="app" :style="mainCssVars">
    <keep-alive>
      <component v-if="localizeReady" :is="layout">
        <router-view/>
      </component>
    </keep-alive>

<!--    <fps />-->
  </div>
</template>

<script>
  import search_component from '@/layouts/search';
  // import fps from "./views/baseComponents/fps";
  import { checkIE } from "@/plugins/methods"
  import Vue from "vue";

  export default {
    data() {
      return {
        localizeReady: false,
        debug: Vue.config.debug
      }
    },
    components: {
      search_component,
      // fps
    },
    computed: {
      layout() {
        return search_component
      },
      isDarkTheme() {
        return this.$store.getters['getTheme']
      },
      mainColors(){
        const { mainColor1, mainColor2, mainColor3 } = window.settings
        return {
          mainColor1,
          mainColor2,
          mainColor3
        }
      },
      mainCssVars(){
        const vars =  {
          '--app-color-1': this.isColor(this.mainColors?.mainColor1, '#319AE6'),
          '--app-color-2': this.isColor(this.mainColors?.mainColor2, '#ff7715'),
          '--app-color-3': this.isColor(this.mainColors?.mainColor3, '#1EB65D'),
        }
        return vars
      }
    },
    methods: {
      isColor(strColor, defaultColor){
        const s = new Option().style;
        s.color = strColor;
        return s.color !== '' ? s.color : defaultColor;
      }
    },
    created() {
      // Проверяем зашел ли пользователь через браузер IE
      checkIE();

      let apiUrl = document.getElementById("apiUrl").value;
      if (apiUrl[apiUrl.length-1] !== "/") {
        apiUrl += "/"
      }
      this.$store.dispatch("A_SET_API_URL", apiUrl);
      this.$store.dispatch("tour/A_SET_API_URL", apiUrl);
      this.$store.dispatch("basket/A_SET_API_URL", apiUrl);
      this.$store.dispatch("tickets/A_SET_API_URL", apiUrl);
      this.$store.dispatch("quotes/A_SET_API_URL", apiUrl);
      this.$store.dispatch("hotels/A_SET_API_URL", apiUrl);

      /* Устанавлеваем origin для запросов */
      let apiOrigin = window.location.origin + "/";
      if (this.debug)
        apiOrigin = "http://localhost/";

      this.$store.dispatch("A_SET_API_ORIGIN", apiOrigin);
      this.$store.dispatch("tour/A_SET_API_ORIGIN", apiOrigin);
      this.$store.dispatch("basket/A_SET_API_ORIGIN", apiOrigin);
      this.$store.dispatch("tickets/A_SET_API_ORIGIN", apiOrigin);
      this.$store.dispatch("hotels/A_SET_API_ORIGIN", apiOrigin);

      /* Устанавлеваем path для запросов */
      let path = window.location.pathname;

      if (this.debug)
        path = 'TourSearchClient2';

      this.$store.dispatch("A_SET_PATH", path) ;


      let localCode = localStorage.getItem("localize") || document.getElementById('defaultLanguageCode').value;
      this.$store.dispatch('A_SET_LOCALIZE_LIST', localCode)
              .then(() => {
                this.localizeReady = true
              })
              .catch(() => {
                this.localizeReady = true
              })
    },
      watch: {
          isDarkTheme(val) {
              document.body.classList[val ? "add" : "remove"]("dark-theme")
          }
      }
  }
</script>

<style>
@import "assets/css/global.css";
@import "assets/css/variables.css";
@import "assets/css/darkTheme.css";
@import "assets/font/fonts.css";
</style>
